// extracted by mini-css-extract-plugin
module.exports = {"teaser":"teaserJp_teaser__GUNU8"};